import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {Split} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {CloudDownloadLine} from '@dropbox/dig-icons/assets';
import {usePendingAction} from 'hooks/usePendingAction';
import i18n from 'i18next';

/** "10 of 2,872", a show more/fewer toggle, and a download of every row. */
export const AiQueryInlineTableFooter = ({
  shown,
  total,
  canExpand,
  isExpanded,
  onToggle,
  onDownload,
  onDownloadError,
}: {
  shown: number;
  total: number;
  canExpand: boolean;
  isExpanded: boolean;
  onToggle: () => void;
  onDownload: () => Promise<void>;
  onDownloadError?: (error: unknown) => void;
}) => {
  const download = usePendingAction(onDownload, onDownloadError);

  return (
    <Split gap="8" alignY="center" paddingTop="8">
      <Split.Item width="fill">
        <Text size="xsmall" color="faint">
          {i18n.t('ai_query_inline_table_count', {
            shown: shown.toLocaleString(),
            total: total.toLocaleString(),
          })}
        </Text>
      </Split.Item>
      {canExpand && (
        <Split.Item>
          <Button variant="transparent" size="small" onClick={onToggle}>
            {i18n.t(
              isExpanded ? 'ai_query_inline_table_show_fewer' : 'ai_query_inline_table_show_more'
            )}
          </Button>
        </Split.Item>
      )}
      <Split.Item>
        <Button
          variant="transparent"
          size="small"
          withIconStart={<UIIcon src={CloudDownloadLine} />}
          disabled={download.isPending}
          onClick={() => void download.run()}
        >
          {i18n.t('ai_query_inline_table_download', {total: total.toLocaleString()})}
        </Button>
      </Split.Item>
    </Split>
  );
};
